import { intersectionObserve } from "./_intersection-observer";

document.addEventListener("DOMContentLoaded", function() {
  const block = document.querySelector('section.funds-presentation');

  if(block) {
    const fundsMeta = block.querySelectorAll('.fund-meta');
    if(fundsMeta.length > 0) {
      fundsMeta.forEach(function(fund, index) {
        const icon = fund.querySelector('svg');

        if(icon) {
          let iconTop;
          let iconOffset = null;
          icon.querySelectorAll('path').forEach(function(path, index) {
            if(iconOffset == null) {
              iconOffset = path.getBoundingClientRect().top;
              iconTop = path.getBoundingClientRect().height;
            }
            else if(path.getBoundingClientRect().top < iconOffset) {
              iconTop = path.getBoundingClientRect().height;
            }
          });
          icon.style.marginTop = (0 - (iconTop)) + 'px';
        }
      });

      window.addEventListener('resize', function() {
        fundsMeta.forEach(function(fund, index) {
          const icon = fund.querySelector('svg');
  
          if(icon) {
            let iconTop;
            let iconOffset = null;
            icon.querySelectorAll('path').forEach(function(path, index) {
              if(iconOffset == null) {
                iconOffset = path.getBoundingClientRect().top;
                iconTop = path.getBoundingClientRect().height;
              }
              else if(path.getBoundingClientRect().top < iconOffset) {
                iconTop = path.getBoundingClientRect().height;
              }
            });
            icon.style.marginTop = (0 - (iconTop)) + 'px';
          }
        });
      });
    }

    const elements = block.querySelectorAll('a.fund-link');
    const metaContainer = block.querySelector('.meta-container');
    const metaContainerHeight = metaContainer.getBoundingClientRect().height + document.querySelector('header').getBoundingClientRect().height;
    const linkPaddingTop = parseFloat(window.getComputedStyle(elements[0], null).getPropertyValue('padding-top'));
    const rootMargin = (metaContainerHeight - (window.innerHeight * 0.95) + linkPaddingTop);
    intersectionObserve(elements, rootMargin, 1, (element, intersectionRatio) => {
        (function(el) {
          const meta = el.closest('.funds-presentation').querySelector('.meta-container .fund-meta[data-slug="' + el.getAttribute('data-slug') + '"]');
          if (intersectionRatio == 1 && !el.closest('.fund').classList.contains('show') && window.innerWidth >= 1024) {
            if(block.querySelector('.fund.show')) {
                  block.querySelector('.fund.show').classList.remove('show');
                }
                el.closest('.fund').classList.add('show');
                if(!meta.classList.contains('show')) {
                  block.querySelector('.meta-container .fund-meta.show').classList.remove('show');
                  meta.classList.add('show');
                }
            }
        })(element);
    });
  }
});